import VehicleModel from 'models/VehicleModel';

const getFullVehicleName = (vehicle: VehicleModel | null | undefined) => {
    if (!vehicle) {
        return '';
    }
    return `${vehicle?.year ? `${vehicle.year} ` : ''}${vehicle?.make ? vehicle?.make : ''} ${
        vehicle?.model ? vehicle?.model : ''
    } ${vehicle?.series ? vehicle?.series : ''}`;
};

export default getFullVehicleName;
